
import { SaleType } from "@/models/base";
import { SaleService } from "@/services/sale-service";
import { TranslateResult } from "vue-i18n";
import { FormLike } from "winfakt-vue-components/src/mixins/form-like";

export default FormLike.extend({
	data(){
		return {
			typeName: "",
			pluralName: ""
		};
	},
	props: {
		contactGroupId: Number
	},
	computed: {
		title():TranslateResult {
			return this.$ct("create-new-document-type");
		}
	},
	methods: {
		cancel(){
			this.$emit("close");
		},
		async submit(){
			this.validate();
			let saleType = new SaleType();
			saleType.ContactGroupID = this.contactGroupId;
			saleType.Name.setText(this.typeName);
			saleType.DisplayedName = this.typeName;
			saleType.NamePlural = this.pluralName;
			let result = await SaleService.createType(saleType);
			this.$emit("saved", result);
			this.$emit("close");
		}
	},
	i18nEx: {
		componentPrefix: "components.sale-settings"
	}
});
